import {
  clampMetronomeBpm,
  METRONOME_BPM_MAX,
  METRONOME_BPM_MIN,
} from '../lib/presentationTempo';

interface MetronomeBpmPickerProps {
  bpm: number;
  suggested: number;
  custom: boolean;
  onBpmChange: (bpm: number) => void;
  onUseSuggested: () => void;
}

/** Prominent inline tempo control (pre-round in lessons). */
export default function MetronomeBpmPicker({
  bpm,
  suggested,
  custom,
  onBpmChange,
  onUseSuggested,
}: MetronomeBpmPickerProps) {
  return (
    <div className="mt-5 rounded-xl bg-white/70 p-4 text-left ring-1 ring-emerald-200/80 dark:bg-zinc-900/50 dark:ring-emerald-500/25">
      <div className="flex items-baseline justify-between gap-2">
        <p className="text-xs font-semibold text-strong">Tempo</p>
        <p className="font-mono text-lg font-bold tabular-nums text-indigo-600 dark:text-indigo-300">
          {bpm} BPM
        </p>
      </div>
      <input
        type="range"
        min={METRONOME_BPM_MIN}
        max={METRONOME_BPM_MAX}
        step={1}
        value={bpm}
        onChange={(e) => onBpmChange(clampMetronomeBpm(Number(e.target.value)))}
        className="mt-2 w-full accent-emerald-500"
        aria-label="Metronom-tempo i BPM"
      />
      <div className="mt-1 flex justify-between text-[10px] text-faint">
        <span>{METRONOME_BPM_MIN}</span>
        <span>{METRONOME_BPM_MAX}</span>
      </div>
      <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-muted">
          Anbefalet:{' '}
          <span className="font-mono font-medium text-strong">
            {suggested} BPM
          </span>
          {custom ? ' · dit valg' : ''}
        </p>
        {custom && (
          <button
            type="button"
            onClick={onUseSuggested}
            className="text-xs font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-400"
          >
            Brug anbefalet
          </button>
        )}
      </div>
    </div>
  );
}
